module.exports = __webpack_public_path__ + "static/img/welcome.d3f37d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome.jpg
// module id = 2QhH
// module chunks = 44